module.exports = __webpack_public_path__ + "static/media/rickandmorty-min.25cd06de.png";